import { render, staticRenderFns } from "./FeatureForm.vue?vue&type=template&id=02fb5521"
import script from "./FeatureForm.vue?vue&type=script&lang=ts"
export * from "./FeatureForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports